import TicketComposantController from './ticket.composant.controller';
import template from './ticket.composant.html';

export default {
	bindings: {
		id: '=',
		domaine: '=',
		isOpen: '=',
		onUpdate: '&',
		onTicketLoaded: '&?'
	},
	template: template,
	controller: TicketComposantController
};
